import React from "react";
import { withAuth } from "shared/context/Auth";
import Avatar from "backpack-ui/dist/components/avatar";
import Icon from "backpack-ui/dist/components/icon";
import { Divider } from "shared/layout";
import config from "../../config";
import styles from "./styles.css";

const UserHeader = ({ auth }) => {
  if (auth.isUserSignedIn) {
    const { user } = auth;
    const userSettingsItem = config.getUserSettingsItem(user);
    const userProfileItem = config.getUserProfileItem(user);

    return (
      <React.Fragment>
        <header className={styles.userHeader}>
          <a
            className={styles.userHeaderAvatar}
            href={userProfileItem.url}
            title={userProfileItem.title}
          >
            <Avatar src={user.avatar} alt={user.username} size={24} />

            <span className={styles.userHeaderUsername}>{user.username}</span>
          </a>

          <a
            className={styles.userHeaderSettings}
            href={userSettingsItem.url}
            title={userSettingsItem.title}
          >
            <Icon.Gear />
          </a>
        </header>

        <Divider
          className={styles.userHeaderDivider}
        />
      </React.Fragment>
    );
  }

  return null;
};

export default withAuth(UserHeader);
